/* global axios */
import ApiClient from './ApiClient';

class AttributeAPI extends ApiClient {
  constructor() {
    super('custom_attribute_definitions', { accountScoped: true });
  }

  getAttributesByModel(attributeModel = null) {
    const params = attributeModel ? { attribute_model: attributeModel } : {};
    return axios.get(this.url, { params });
  }

  update(id, payload) {
    return axios.put(`${this.url}/${id}`, payload);
  }
}

export default new AttributeAPI();
